import { render, staticRenderFns } from "./index-drawer.vue?vue&type=template&id=b6892960&"
import script from "./index-drawer.vue?vue&type=script&lang=js&"
export * from "./index-drawer.vue?vue&type=script&lang=js&"
import style0 from "./index-drawer.vue?vue&type=style&index=0&id=b6892960&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports